// ** React Imports
import { lazy } from 'react';

const ListRoads = lazy(() => import('../../views/ranking/road'));
const ListEmotions = lazy(() => import('../../views/ranking/emotions'));

const RankingRoutes = [
  {
    element: <ListRoads />,
    path: '/ranking/roads',
    meta: {
      permission: 'RANKING'
    }
  },
  {
    element: <ListEmotions />,
    path: '/ranking/emotions',
    meta: {
      permission: 'RANKING'
    }
  }
];

export default RankingRoutes;
